import sileo from 'sileo';
import axios from 'source/lib/axios';
const SimpleFormDocument = new sileo.Model('generic_form', 'simple-form-document');
const FormDocument = new sileo.Model('generic_form', 'form-document');
const FormResponse = new sileo.Model('generic_form', 'form-response');
const FormDocumentAssignment = new sileo.Model('generic_form', 'form-document-assignment');
const SummaryFormDocument = new sileo.Model('generic_form', 'summary-form-document');
const WorkforceMembers = new sileo.Model('generic_form', 'workforce-members');
const FormDocumentRecipients = new sileo.Model('generic_form', 'form-document-recipients');
const PendingFormDocument = new sileo.Model('generic_form', 'pending-form-document');
const FormDocumentDetails = new sileo.Model('generic_form', 'form-document-details');
const PersonalMilestoneFormDocumentAssignment = new sileo.Model(
    'generic_form', 'personal-milestone-form-document-assignment');
const RestoreForm = new sileo.Model('generic_form', 'restore-form-document');
const Signatories = new sileo.Model('generic_form', 'signatories');
const CheckFormStateAndPermission = new sileo.Model('generic_form', 'form-permission-state');
const FormResponseExport = new sileo.Model('generic_form', 'form-response-export');

const state = {
    existingResponses: []
};

const mutations = {
    setExistingResponses(state, data) {
        state.existingResponses = data;
    }
};

const actions = {
    fetchForms(context, filters) {
        // Note: This api needs a `content_id` (workforce_id) param to be passed
        return SimpleFormDocument.objects.filter(filters);
    },

    getForm(_, id) {
        return FormDocument.objects.get(id);
    },

    fetchFormDocumentDetails(_, id) {
        return FormDocumentDetails.objects.get(id);
    },

    updateFormDocument(context, data) {
        return FormDocumentDetails.objects.update({ 'pk': data.pk }, data);
    },

    restoreFormDocument(context, data) {
        return RestoreForm.objects.update({ 'pk': data.pk });
    },

    createFormResponse(context, data) {
        const payload = new FormData();

        for (let field in data) {
            if (field === 'responses') {
                data['responses'] = JSON.stringify(data.responses);
            }

            payload.append(field, data[field]);
        }

        return FormResponse.objects.create(payload);
    },

    updateFormResponse(context, data) {
        const payload = new FormData();

        let documentId = null;
        for (const field in data) {
            if (field === 'document_id') {
                documentId = data[field];
                continue;
            }

            if (field === 'responses') {
                data['responses'] = JSON.stringify(data.responses);
            }

            payload.append(field, data[field]);
        }

        const filter = {
            pk: documentId,
        };
        return FormResponse.objects.update(filter, payload);
    },

    getFormDocumentAssignment(context, data) {
        return FormDocumentAssignment.objects.filter(data);
    },

    getPersonalMilestoneFormDocumentAssignment(context, data) {
        return PersonalMilestoneFormDocumentAssignment.objects.filter(data);
    },

    getSummaryForm(_, id) {
        return SummaryFormDocument.objects.get(id);
    },

    updateSummaryForm(context, data) {
        const form = new FormData();

        let pk = data.pk,
            dataKeys = Object.keys(data);

        dataKeys.forEach(key => {
            form.append(key, data[key]);
        });

        return SummaryFormDocument.objects.update({ 'pk': pk }, form);
    },

    fetchWorkforceMembers(context, data) {
        return WorkforceMembers.objects.filter(data);
    },

    createFormDocument(context, data) {
        return FormDocument.objects.create(data);
    },

    fetchFormDocumentRecipients(context, data) {
        return FormDocumentRecipients.objects.filter(data);
    },

    fetchPendingForms(_, data) {
        return PendingFormDocument.objects.filter(data);
    },

    deleteFormDocument(context, data) {
        return FormDocument.objects.delete(data);
    },

    fetchSignatories(context, filter) {
        return Signatories.objects.filter(filter);
    },

    checkFormPermissionState(context, filter) {
        return CheckFormStateAndPermission.objects.filter(filter);
    },

    createFormResponseExport(context, data) {
        return FormResponseExport.objects.create(data);
    },

    fetchFormResponseExports(context, filters) {
        return FormResponseExport.objects.filter(filters);
    },

    cancelFormResponseExport(context, filters) {
        return FormResponseExport.objects.update(filters, new FormData());
    },

    deleteFormResponseExport(context, filters) {
        return FormResponseExport.objects.delete(filters);
    },

    downloadFormResponseExport(context, params) {
        return axios.get('generic-form/form-response-export-csv', {
            params: params,
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
